<template>
    <div class="articles">
        <div class="articles-list" v-for="(article) in addedArticles.articles" v-bind:key="article.id">
        
            <div class="select-option--text">
                <p class="magenta"><a href="">{{article.title}}</a></p>
                 <p class="dateAndTags"><span v-html="article.dateString"></span></p>
                <div class="articles-list__blurb" v-html="article.blurb"></div>
                <p><a :href="article.url">Read More</a></p>
                <hr>
            </div>              
        </div> 
    </div>
</template>

<script>
    export default {
        name: "ArticleList",
        
        props: {
            introduction: String,
            addedArticles: Object,
        }     
    };
</script>